/**
 * RECEIVE-ONLY CLIENTS, the screen's copy of api/src/lib/receive-only.ts (his word "Proceed with all",
 * relayed by the program office 3 Oct 2026, chat stamped 1:50 AM). A client is texted, emailed, called
 * back or pressed for a kit from this console only when it has a texting number of its own; today that
 * is Alignment alone. Every other client's queue is read, noted, marked Opt Out or STOP, and closed.
 * The server refuses the rest by itself; this copy only keeps the buttons from offering what it refuses.
 * Pinned in lockstep with the API's list by tests/unit/receive-only.test.ts.
 */
export const TEXTING_CLIENTS: readonly string[] = ['alignment'];

export function isReceiveOnly(client: string): boolean {
  return !TEXTING_CLIENTS.includes(client);
}

export const RECEIVE_ONLY_WORDING = {
  pill: 'Receive-only',
  note: 'This plan has no texting number of its own, so this console never texts, emails, calls back or ships a kit to its members. Read the entry, note it, record Opt Out or STOP, and close it.',
  pressRefused: 'Not offered for this plan: it is receive-only (no texting number of its own).',
  // L3 (4 Oct 2026, Client Wall rule 1): the case panel's Conversation section for a receive-only plan.
  texts: 'Texts are not shown for this plan. The texting platform files texts by phone number, not by plan, so it could show another plan\'s texts. This plan\'s messages arrive in this queue only.',
  // M1 part B (his R. 184 rows 872-1 and 872-4, 4 Oct 2026): the note when member email is open for the
  // plan (MEMBERCARE_EMAIL_REPLY on and the plan's own mailbox named). The API's RECEIVE_ONLY_MESSAGE_EMAIL,
  // word for word, pinned by tests/unit/email-reply-screen.test.tsx.
  noteEmail: 'This plan has no texting number of its own, so this console never texts, calls back or ships a kit to its members; a member\'s email is answered by email from the plan\'s own mailbox. Read the entry, note it, record Opt Out or STOP, answer an email by email, and close it.',
} as const;

/** The receive-only note that is true for the plan: email is named only when it is open. */
export function receiveOnlyNote(emailOpen: boolean): string {
  return emailOpen ? RECEIVE_ONLY_WORDING.noteEmail : RECEIVE_ONLY_WORDING.note;
}

/**
 * W9 (00 Main's RULED 01.59.17 AM, 11 Oct 2026): the screen's copies of the server's two call-check sentences
 * (api/src/lib/receive-only.ts), pinned in lockstep by tests/unit/call-guard.test.tsx. Neither names a reason, a
 * plan or a person. lib/call-guard.ts shows the second when the check could not be made.
 */
export const NOT_CALLABLE_SENTENCE = 'This number cannot be called.';
export const CALL_CHECK_FAILED_SENTENCE = 'This number cannot be called. The stop check could not finish.';

/**
 * SENDWORDS (the office's 03.30.48 PM letter T-1010-99, 11 Oct 2026): the screen's copy of the server's one sentence for
 * a text held because the stop list could not be read (api/src/lib/receive-only.ts STOP_LIST_UNREADABLE_SENTENCE),
 * pinned in lockstep by tests/integration/care-sms.test.ts and tests/unit/number-picker.test.tsx. The text box and the
 * video test show the server's own words; this copy is what keeps the two from drifting apart.
 */
export const STOP_LIST_UNREADABLE_SENTENCE = 'NOT SENT: the stop list could not be read, so this text was held. Try again in a minute.';
